import React from 'react';
import {useTranslation} from "react-i18next";
import {NavButton, PageInfo, PageNavigationWrapper} from './PageNavigation.styled';
import {ArrowBackIos, ArrowForwardIos} from "@mui/icons-material";


interface PageNavigationProps {
    currentPage: number;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
    totalPages: number;
}

const PageNavigation = ({
    currentPage, setCurrentPage, totalPages
}: PageNavigationProps) => {
    const { t } = useTranslation();

    return (
        <PageNavigationWrapper role="navigation" aria-label={t('ocr.aria.navigation')}>
            <NavButton
                onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                disabled={currentPage === 1}
                aria-label={t('ocr.aria.navigationPreviousPage')}
            >
                <ArrowBackIos sx={{ fontSize: 14 }} />
            </NavButton>

            <PageInfo>
                {t('ocr.page.info', { current: currentPage, total: totalPages })}
            </PageInfo>

            <NavButton
                onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                disabled={currentPage === totalPages}
                aria-label={t('ocr.aria.navigationNextPage')}
            >
                <ArrowForwardIos sx={{ fontSize: 14 }} />
            </NavButton>
        </PageNavigationWrapper>
    );
};

export default PageNavigation;